import { useState } from 'react';
import { useClub } from '../../hooks/useClub';
import CompQueue from './CompQueue';
import LeakageWatchlist from './LeakageWatchlist';
import GoalPacing from './GoalPacing';
import LeagueFeeLeakage from './LeagueFeeLeakage';
import CrossClubUpsell from './CrossClubUpsell';
import StaffDiscounts from './StaffDiscounts';

const MODULE_TABS = [
  { key: 'comp',        label: '💳 Comp Queue' },
  { key: 'leakage',     label: '⚠️ Leakage Watchlist' },
  { key: 'leagueFee',   label: '🎾 League Fee Leakage' },
  { key: 'crossClub',   label: '📈 Upsell Leads' },
  { key: 'staffDiscounts', label: '🏷️ Staff Discounts' },
  { key: 'goals',       label: '🎯 Goal Pacing' },
];

export default function RevenueModule() {
  const { currentClub } = useClub();
  const [activeTab, setActiveTab] = useState('comp');

  return (
    <div className="module-page">
      {/* Header */}
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--text)', margin: 0, marginBottom: 4 }}>
          💰 Revenue
        </h1>
        <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
          {currentClub?.name || 'All Clubs'} · Comp Review · Leakage · League Fees · Upsell · Goal Pacing
        </div>
      </div>

      {/* Module tabs */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 4, borderBottom: '1px solid var(--border)' }}>
        {MODULE_TABS.map(t => (
          <button
            key={t.key}
            onClick={() => setActiveTab(t.key)}
            style={{
              background: 'none', border: 'none',
              borderBottom: activeTab === t.key ? '2px solid var(--yellow)' : '2px solid transparent',
              color: activeTab === t.key ? 'var(--yellow)' : 'var(--text-muted)',
              padding: '10px 20px', fontSize: 13,
              fontWeight: activeTab === t.key ? 700 : 400,
              cursor: 'pointer', marginBottom: -1,
              transition: 'color 0.15s',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      {activeTab === 'comp'      && <CompQueue key={`comp-${currentClub.id}`} />}
      {activeTab === 'leakage'   && <LeakageWatchlist key={`leakage-${currentClub.id}`} />}
      {activeTab === 'leagueFee' && <LeagueFeeLeakage key={`leagueFee-${currentClub.id}`} />}
      {activeTab === 'crossClub' && <CrossClubUpsell key={`crossClub-${currentClub.id}`} />}
      {activeTab === 'staffDiscounts' && <StaffDiscounts key={`staffDiscounts-${currentClub.id}`} />}
      {activeTab === 'goals'     && <GoalPacing key={`goals-${currentClub.id}`} />}
    </div>
  );
}
